import { render, staticRenderFns } from "./otherOpportunityGap.vue?vue&type=template&id=3a4ec748&scoped=true"
import script from "./otherOpportunityGap.vue?vue&type=script&lang=js"
export * from "./otherOpportunityGap.vue?vue&type=script&lang=js"
import style0 from "./otherOpportunityGap.vue?vue&type=style&index=0&id=3a4ec748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ec748",
  null
  
)

export default component.exports